import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Button } from '@totango-app-team/ui-shared-components';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';

import './confirmation-modal.less';

const ConfirmationModal = ({
	isOpen,
	title,
	showHeaderCloseButton,
	className,
	closeModal,
	isLoading,
	confirmationMessage,
	disableBackdropClick,
	disableEscapeKeyDown,
	cancelText,
	onCancel,
	submitText,
	onSubmit,
	submitButtonDisabled,
	showCancel,
	showSubmit,
	submitTooltip,
}) => {
	const closeButton = showHeaderCloseButton ? (
		<span className="material-icons close" onClick={closeModal}>
			close
		</span>
	) : (
		''
	);
	return (
		<Dialog
			open={isOpen}
			classes={{
				root: `confirmation-dialog confirmation-modal ${className}`,
				paper: 'confirmation-dialog-paper',
			}}
			onClose={closeModal}
			disableEscapeKeyDown={disableEscapeKeyDown}
			disableBackdropClick={disableBackdropClick}
		>
			{title ? <DialogTitle className="dialog-title">{title}</DialogTitle> : ''}
			{closeButton}
			<DialogContent className="dialog-content">
				<div className="confirmation-msg">{confirmationMessage}</div>
			</DialogContent>
			<DialogActions className="dialog-actions">
				{showCancel && (
					<Button className="confirmation-dialog-button cancel" onClick={onCancel}>
						{cancelText}
					</Button>
				)}
				{showSubmit && (
					<Button
						className="confirmation-dialog-button submit"
						variant="contained"
						color="primary"
						isLoading={isLoading}
						onClick={onSubmit}
						disabled={submitButtonDisabled}
						title={submitTooltip}
					>
						{submitText}
					</Button>
				)}
			</DialogActions>
		</Dialog>
	);
};

ConfirmationModal.defaultProps = {
	isOpen: false,
	closeModal: noop,
	className: '',
	submitButtonDisabled: false,
	isLoading: false,
	showCancel: true,
	cancelText: '',
	onCancel: noop,
	showSubmit: true,
	submitText: '',
	onSubmit: noop,
	showHeaderCloseButton: false,
	disableEscapeKeyDown: true,
	disableBackdropClick: true,
	submitTooltip: '',
};

ConfirmationModal.propTypes = {
	isOpen: PropTypes.bool,
	isLoading: PropTypes.bool,
	className: PropTypes.string,
	closeModal: PropTypes.func,
	confirmationMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
	cancelText: PropTypes.string,
	onCancel: PropTypes.func,
	submitText: PropTypes.string,
	onSubmit: PropTypes.func,
	submitButtonDisabled: PropTypes.bool,
	showCancel: PropTypes.bool,
	showSubmit: PropTypes.bool,
	showHeaderCloseButton: PropTypes.bool,
	disableEscapeKeyDown: PropTypes.bool,
	disableBackdropClick: PropTypes.bool,
	submitTooltip: PropTypes.string,
};

export default ConfirmationModal;
